/*
 * Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
 */

export interface BillingDetail {
  practiceId: string;
  patientId: string;
  paymentSource: string;
  sourceUrnPrefix: string;
  isBalanceEnabled: boolean;
  isGuestPayEnabled: boolean;
  isVisitChargeEnabled: boolean;
  isVisitChargeEditable: boolean;
  isMobileView: boolean;
  optionalConfig?: OptionalData;
}

export interface OptionalData {
  [key: string]: string | boolean;
}

export class Report {
  public mmid = 0;
  public startDate = "";
  public endDate = "";
  public status = "";
  public fileName = "";
  public instructionId = "";
  public fundingDate = "";
  public achDate = "";
  public ledgerType = "";
  public merchantId = 0;
  public processorMerchantId = "";
  public amount = "";
  public type = "";
  public accountType = "";
  public subMerchantName = "";
  public reportGroup = "";
  public response = "";
  public responseTime = "";
  public message = "";
  public fundingStatus = "";
  public achstatus = "";
  public achType = "";
  public fundingId = "";
  public achStatus = "";
  public submerchantName = "";
  public suppressFeeSettlement = "";
  public CHARGEBACK_FEE = "";
}
